import fp from 'lodash/fp';
import * as actions from './actions';
import * as constants from './constants';
import { getTimeStamp } from '../webcommon/common/helpers';

export const INITIAL_STATE = {
    userName: '',
    email: '',
    initialisedStatusPage: false,
    initialisedUserProfile: false,

    loadingStatusPage: false,
    loadingUserProfile: false,

    lastUpdatedStatusPage: getTimeStamp(),
    lastUpdatedUserProfile: getTimeStamp(),

    columnsForStatusPage: [],
    columnsForUserProfile: [],

    rowsForStatusPage: [],
    rowsForUserProfile: [],

    userRole: [],

    statusSql: 'Not Connected'
};

const setStatusPageInitialised = fp.set('initialisedStatusPage');
const setStatusPageLoading = fp.set('loadingStatusPage');
const setUserProfileInitialised = fp.set('initialisedUserProfile');
const setUserProfileLoading = fp.set('loadingUserProfile');
export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {        
        case actions.SET_STATUS_PAGE_INITIALISED:
            return setStatusPageInitialised(action.initialised, state);
        case actions.SET_USER_PROFILE_INITIALISED:
            return setUserProfileInitialised(action.initialised, state);

        case actions.SET_STATUS_PAGE_LOADING:
            return setStatusPageLoading(action.loading, state);   
        case actions.SET_USER_PROFILE_LOADING:
            return setUserProfileLoading(action.loading, state); 

        case actions.SET_SQL_STATUS: {
            return {
                ...state,
                rowsForStatusPage: action.rows,
                lastUpdatedStatusPage: getTimeStamp(),
                loadingStatusPage: false
                };
            }   
        case actions.SET_SQL_STATUS_FOR_IMAGE: {
            return {
                    ...state,
                    statusSql: action.status
                    };
                }  

        case actions.SET_USER_ROLE: {
            return {
                    ...state,
                    userRole: action.role,
                    };
                }   
        case actions.SET_USER_INFO: {
            return {
                    ...state,
                    rowsForUserProfile: action.info,                    
                    lastUpdatedUserProfile: getTimeStamp(),
                    loadingUserProfile: false
                    };
                }
        default:
            return state;
    }
}
